import {
  ColDef,
  ICellRendererParams,
  ValueGetterParams,
} from 'ag-grid-community';
import {
  createAdministratorNameCol,
  createBadgeCol,
  createCustomCol,
  createDateHasAllTimeCol,
  createDetailButtonColV2,
  createIdCol,
  createIndexCol,
  createNumberCol,
  createStatusBadgeCol,
  createTypoCol,
  createViewableCol,
} from '@/src/helpers/agColumnHelper';
import dayjs from 'dayjs';
import { formatter } from '@/src/utils/formatter';

export const magazineViewHistoryListColumn: ColDef[] = [
  createIndexCol(),
  createTypoCol({
    field: 'nick',
    minWidth: 130,
    headerName: '닉네임',
  }),
  createTypoCol({
    field: 'name',
    minWidth: 130,
    headerName: '이름',
  }),
  createNumberCol({
    field: 'count',
    minWidth: 130,
    headerName: '조회 수',
  }),
  createCustomCol({
    field: 'creditYn',
    minWidth: 130,
    cellRenderer: ({ value }: ICellRendererParams) => value,
    headerName: '크레딧 획득 여부',
  }),
  createCustomCol({
    field: 'phone',
    minWidth: 130,
    cellRenderer: ({ value }: ICellRendererParams) => formatter.PHONE(value),
    headerName: '핸드폰 번호',
  }),
];

export const magazineListColumn = (
  onDetailClick: (id: number) => void,
): ColDef[] => [
  createIdCol(),
  createBadgeCol({
    field: 'magazineType',
    size: 'sm',
    options: [
      { label: '일반', value: 'common', color: 'lightYellow' },
      { label: '광고', value: 'advertising', color: 'lightPurple' },
    ],
    headerName: '매거진 유형',
  }),
  createCustomCol({
    field: 'postedAt',
    size: 'md',
    cellRenderer: (params: ValueGetterParams) => {
      return `${dayjs(params?.data?.magazinePostStartedAt).format(
        'YYYY-MM-DD',
      )} ~ ${dayjs(params?.data?.magazinePostEndedAt).format('YYYY-MM-DD')}`;
    },
    headerName: '게시 기간',
  }),
  createViewableCol({
    field: 'isExposed',
    size: 'xs',
    headerName: '노출 여부',
  }),
  createStatusBadgeCol({
    field: 'priorityDisplayYn',
    type: 'isApplied',
    size: 'sm',
    headerName: '우선 노출 여부',
  }),
  createTypoCol({
    field: 'title',
    size: 'lg',
    headerName: '제목',
  }),
  createStatusBadgeCol({
    field: 'awardedCreditYn',
    type: 'isAwarded',
    size: 'sm',
    headerName: '크레딧 지급 여부',
  }),
  createNumberCol({
    field: 'magazineViewHistoryCount',
    size: 'sm',
    headerName: '조회 수',
  }),
  createNumberCol({
    field: 'magazineBookmarkCount',
    size: 'sm',
    headerName: '북마크 수',
  }),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    headerName: '등록 일시',
  }),
  createAdministratorNameCol({
    size: 'sm',
    headerName: '등록 관리자',
  }),
  createDetailButtonColV2(onDetailClick),
];
